export enum CompanyAdminNavItem {
  CompanyAdmin = "NAVIGATION.COMPANY_ADMIN",
  Company = "NAVIGATION.COMPANY",
  Team = "NAVIGATION.TEAM",
  Person = "NAVIGATION.PERSON"
}
